import React from 'react';
import './Mission.css';

const Mission = () => {
  return (
    <section id="mission" className="mission">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Mission</h2>
          <div className="title-underline"></div>
        </div>
        
        <div className="mission-content">
          <div className="mission-card">
            <p>
              Our mission is to provide authentic Islamic education in Arabic, Quran, Hadith, 
              and the practical aspects of Islam. We aim to guide individuals in understanding 
              and applying Islamic teachings in their daily lives, making Islamic knowledge 
              accessible, useful, and meaningful.
            </p>
          </div>
          
          <div className="mission-pillars">
            <div className="pillar">
              <div className="pillar-icon">📜</div>
              <h4>Arabic</h4>
              <p>Master the language of the Quran</p>
            </div>
            
            <div className="pillar">
              <div className="pillar-icon">📖</div>
              <h4>Quran</h4>
              <p>Deep understanding of the Holy Book</p>
            </div>
            
            <div className="pillar">
              <div className="pillar-icon">🕌</div>
              <h4>Hadith</h4>
              <p>Learn from the Prophet's teachings</p>
            </div>
            
            <div className="pillar">
              <div className="pillar-icon">🕋</div>
              <h4>Practical Islam</h4>
              <p>Apply teachings in daily life</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
